import styled, { useTheme } from 'styled-components'
import { ReactNode } from 'react'
import { formatDigest } from '@mysten/sui/utils'

import { Dialog } from 'components/Dialog/Dialog'

import { Button } from 'components/Button/Button'
import { Typography } from 'components/Typography/Typography'
import { getDisplayTimestamp } from 'utils/helpers'
import { IconLink } from 'components/Icons/IconLink'
import { Activity } from './styles'

interface Props {
  kind: string
  timestampMs: number
  transactionDigest: string
  details: ReactNode
  onClose: () => void
}

const DialogActions = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  gap: 32px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    gap: 16px;
  }
  & > button {
    width: 100%;
  }
`

const EventDetails = styled.div`
  padding: 12px 0;
  & > div {
    flex-wrap: wrap;
    & > div {
      flex-wrap: wrap;
    }
  }
`

const TxLink = styled.a`
  text-decoration: underline;
  display: flex;
  align-items: center;
  & > div {
    display: flex;
    align-items: center;
  }
  & > div > svg {
    margin-left: 4px;
  }
`

export const EventDetailsDialog = ({ kind, timestampMs, transactionDigest, details, onClose }: Props) => {
  const theme = useTheme()

  return (
    <Dialog
      title={
        <Typography variant="caption" style={{ display: 'flex', alignItems: 'center' }}>
          <Activity $type={kind} style={{ marginRight: 16 }}>
            {kind}
          </Activity>
          <span style={{ marginRight: 16 }}>{getDisplayTimestamp(timestampMs)}</span>
        </Typography>
      }
      isOpen={true}
      onClose={onClose}
    >
      <EventDetails>{details}</EventDetails>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="body" fontWeight="medium" style={{ marginRight: 8 }}>
          Transaction:
        </Typography>
        <TxLink href={`https://suivision.xyz/txblock/${transactionDigest}`} target="_blank" rel="noreferrer">
          <Typography variant="body" fontWeight="medium">
            {formatDigest(transactionDigest)} <IconLink stroke={theme.colors.text.primary} />
          </Typography>
        </TxLink>
      </div>
      <DialogActions>
        <Button onClick={onClose}>OK</Button>
      </DialogActions>
    </Dialog>
  )
}
